export const getDestinationCraneUOFilter = state => state.destinationCraneMaster.filter
